import { LottoCertificazioniDto, LottoDto, StatoLottoEnum } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { DettaglioCampagnaReducerType, FormRicercaCertificati } from "./types";



const dettaglioCampagnaReducer = (state: RootState) => state.dettaglioCampagna;


export const certificazioniLotto = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): LottoCertificazioniDto[] => {
    return state.certificazioniLotto?.items || [];
  }
);

export const dettaglioLotto = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): LottoDto | undefined => {
    return state.dettaglioLotto;
  }
);

export const dettaglioLottoCompletato = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): boolean | undefined => {
    return state.dettaglioLotto?.idStatoLotto === StatoLottoEnum.NUMBER_4;
  }
);

export const dettaglioLottoInEsecuzione = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): boolean | undefined => {
    return state.dettaglioLotto?.idStatoLotto === StatoLottoEnum.NUMBER_2;
  }
);

export const dettaglioLottoInserito = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): boolean | undefined => {
    return state.dettaglioLotto?.idStatoLotto === StatoLottoEnum.NUMBER_1;
  }
);

export const paginaSelezionataSelector = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): number => {
    return state?.paginaSelezionata;
  }
);
export const isFirstPageSelector = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): boolean => {
    return !!state.certificazioniLotto?.isFirstPage;
  }
);
export const isLastPageSelector = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): boolean => {
    return !!state.certificazioniLotto?.isLastPage;
  }
);
export const numeroTotalePagineSelector = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): number | undefined => {
    return state.certificazioniLotto?.pageCount;
  }
);
export const formRicercaCertificatiSelector = createSelector(
  dettaglioCampagnaReducer,
  (state: DettaglioCampagnaReducerType): FormRicercaCertificati => {
    return state.formRicerca;
  }
);
